/*
 * @Author: huangyh
 * @Date: 2021-03-12 11:30:34
 * @LastEditors: huangyh
 * @LastEditTime: 2021-03-12 11:35:15
 */
import QnList from './qnList'
import agOrderList from './agOrderList'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...QnList,
      ...agOrderList
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/questionnaire/index.js